import clickEventName from 'utils/DOM/clickEventName'
import { SnowplowTrigger } from 'Snowplow'
import { getQuestionValueFromState } from 'utils/snowplow/utils/getQuestionValueFromState'
import { getValueFromStorage } from 'utils/snowplow/utils/getValueFromStorage'
import { registerSnowplowTriggers } from 'utils/snowplow/events/userClick/registerSnowplowTriggers'

function registerSnowplowListeners() {
  const triggers: SnowplowTrigger[] = [
    {
      element: '.question__answer__btn',
      description: 'Eligibility - Submits',
      elementTrigger: clickEventName,
      eventType: 'click',
      placement: 'eligibility',
      valueParser: getQuestionValueFromState
    },
    {
      element: '#submit',
      description: 'Eligibility - Submits form',
      elementTrigger: clickEventName,
      eventType: 'click',
      placement: 'eligibility',
      valueParser: getValueFromStorage
    },
    {
      element: '#connect-me-to-an-expert',
      description: 'Eligibility - No eligible - Connect me to an expert',
      elementTrigger: clickEventName,
      eventType: 'click',
      placement: 'eligibility',
      valueParser: getValueFromStorage
    },
    {
      element: '#sherpa-link',
      description: 'Eligibility - No eligible - Show me my options',
      elementTrigger: clickEventName,
      eventType: 'click',
      placement: 'eligibility',
      valueParser: getValueFromStorage
    }
  ]
  registerSnowplowTriggers(triggers)
}

export default registerSnowplowListeners
